import React from 'react';
import SEOLandingPage from './SEOLandingPage';
import {
  getGamesByCategory,
  SEO_GAME_CATALOG,
} from '../../data/seoGameCatalog';
import { SEO_GAME_DETAILS } from '../../data/seoGameDetails';

const CATEGORY_CONFIG = {
  educational: {
    path: '/mokomieji-zaidimai',
    eyebrow: 'MOKYMOSI ŽAIDIMAI VAIKAMS',
    title: 'Mokomieji žaidimai vaikams – SmartPanda',
    description:
      'Interaktyvūs mokomieji žaidimai vaikams. Matematika, skaitymas, lietuvių kalba, logopediniai pratimai, gamtos mokslai ir kūrybinės užduotys vienoje platformoje.',
    h1: 'Mokomieji žaidimai vaikams',
    intro:
      'SmartPanda – tai interaktyvi mokymosi platforma, kurioje vaikai mokosi žaisdami. Užduotys sukurtos taip, kad lavintų matematinius, kalbos, skaitymo, loginio mąstymo ir kūrybinius gebėjimus.',
    about: [
      'mokomieji žaidimai vaikams',
      'interaktyvus mokymasis',
      'mokymasis žaidžiant',
    ],
    learningOutcomes: [
      'Matematinio ir loginio mąstymo lavinimas',
      'Skaitymo ir kalbos įgūdžių stiprinimas',
      'Dėmesio, atminties ir problemų sprendimo lavinimas',
      'Kūrybiškumo ir smalsumo skatinimas',
      'Mokymasis per praktines ir interaktyvias užduotis',
    ],
    contentSections: [
      {
        title: 'Mokymasis per žaidimą',
        text:
          'Žaidybinės užduotys leidžia vaikui mokytis aktyviai. Vietoje vien tik teorijos vaikas sprendžia užduotis, ieško atsakymų, kuria sekas, dėlioja žodžius ir tyrinėja skirtingus scenarijus.',
      },
      {
        title: 'Skirtingos mokymosi sritys',
        text:
          'Platformoje galima rasti matematikos, skaitymo, lietuvių kalbos, kalbos garsų, gamtos mokslų, geografijos, muzikos, istorijos ir kitų temų žaidimų.',
      },
      {
        title: 'Žaidimai skirtingiems mokymosi poreikiams',
        text:
          'Vienoje vietoje pateikiamos tiek paprastos rūšiavimo ir atitikimo užduotys, tiek sudėtingesni galvosūkiai, istorijos, kūrybinės užduotys ir problemų sprendimo scenarijai.',
      },
    ],
    childLinks: [
      {
        path: '/zaidimai-ikimokyklinukams',
        name: 'Mokomieji žaidimai ikimokyklinukams',
      },
      {
        path: '/zaidimai-pradinukams',
        name: 'Mokomieji žaidimai pradinukams',
      },
    ],
    faq: [
      {
        question: 'Kas yra mokomieji žaidimai vaikams?',
        answer:
          'Tai žaidybinės interaktyvios užduotys, skirtos mokytis konkrečių žinių ir lavinti gebėjimus. Vaikas mokosi atlikdamas veiksmus, spręsdamas užduotis ir gaudamas grįžtamąjį ryšį.',
      },
      {
        question: 'Kokių mokomųjų žaidimų yra SmartPanda?',
        answer:
          'SmartPanda kataloge yra matematikos, skaitymo, lietuvių kalbos, logopedinių, gamtos mokslų, geografijos, muzikos, istorijos, kūrybinių ir kitų edukacinių žaidimų.',
      },
      {
        question: 'Ar SmartPanda naudoja dirbtinį intelektą?',
        answer:
          'Taip. SmartPanda platformoje naudojamas dirbtinis intelektas kuriant ir pritaikant mokymosi turinį bei interaktyvias užduotis.',
      },
    ],
  },

  math: {
    path: '/matematikos-zaidimai',
    eyebrow: 'MATEMATIKOS ŽAIDIMAI',
    title: 'Matematikos žaidimai vaikams – SmartPanda',
    description:
      'Smagūs matematikos žaidimai vaikams: skaičiai, lygtys, trupmenos, daugyba, pinigai, laikas, geometrija ir loginės užduotys.',
    h1: 'Matematikos žaidimai vaikams',
    intro:
      'Matematika gali būti įdomi, kai ją galima išbandyti žaidžiant. SmartPanda matematikos žaidimai padeda vaikams praktiškai mokytis skaičių, lygčių, trupmenų, laiko, pinigų, geometrijos ir kitų temų.',
    about: [
      'matematikos žaidimai vaikams',
      'matematikos mokymasis',
      'skaičiavimo įgūdžiai',
      'loginis mąstymas',
      'matematinės užduotys',
    ],
    learningOutcomes: [
      'Skaičių ir skaičiavimo įgūdžių lavinimas',
      'Sudėties, atimties ir matematinių lygčių praktika',
      'Daugybos ir trupmenų supratimas',
      'Laiko, pinigų ir praktinės matematikos įgūdžiai',
      'Loginio ir erdvinio mąstymo lavinimas',
    ],
    childLinks: [
      {
        path: '/skaiciai-ir-skaiciavimas',
        name: 'Skaičiai ir skaičiavimas',
      },
    ],
    relatedLinks: [
      {
        path: '/mokymosi-gidai/kaip-ismokyti-vaika-skaiciuoti',
        name: 'Kaip išmokyti vaiką skaičiuoti?',
      },
    ],
    contentSections: [
      {
        title: 'Matematika per praktiką',
        text:
          'Interaktyvios užduotys leidžia vaikui iš karto pritaikyti matematines žinias. Skaičių tiesė, lygtys, pinigai, laikrodis ir kitos užduotys pateikiamos kaip žaidybiniai iššūkiai. Toks mokymasis padeda ne tik rasti teisingą atsakymą, bet ir suprasti, kaip matematinės taisyklės veikia praktinėse situacijose.',
      },
      {
        title: 'Sudėtis, atimtis ir daugyba',
        text:
          'Kasdienėje matematikoje svarbu tvirtai išmokti pagrindinius veiksmus. Žaidybinės užduotys leidžia vaikui kartoti sudėtį, atimtį ir daugybą skirtingais būdais, palaipsniui didinant užduočių sudėtingumą. Trumpa praktika gali padėti lavinti skaičiavimo greitį, tikslumą ir pasitikėjimą savo gebėjimais.',
      },
      {
        title: 'Nuo skaičių iki geometrijos',
        text:
          'Matematikos kategorijoje galima mokytis skaičių, lygčių, trupmenų, daugybos, laiko, pinigų, geometrijos ir grafikų. Skirtingos temos leidžia vaikui lavinti ne vien skaičiavimo įgūdžius, bet ir gebėjimą pastebėti ryšius, palyginti dydžius, suprasti sekas bei spręsti įvairias matematines užduotis.',
      },
      {
        title: 'Trupmenos, pinigai ir laikas',
        text:
          'Matematika tampa lengviau suprantama, kai ji siejama su kasdieniu gyvenimu. Trupmenų, pinigų ir laiko užduotys padeda vaikui praktiškai pritaikyti skaičiavimo žinias: suprasti dalis, atlikti skaičiavimus su pinigais, perskaityti laiką ir spręsti situacijas, su kuriomis galima susidurti ne tik mokantis, bet ir kasdienybėje.',
      },
      {
        title: 'Loginės matematikos užduotys',
        text:
          'Dalis žaidimų jungia matematiką su istorijomis, galvosūkiais ir kasdienėmis situacijomis. Tokios užduotys skatina vaiką ne tik atlikti veiksmą, bet ir pasirinkti tinkamą sprendimo būdą. Tai padeda lavinti loginį, analitinį ir erdvinį mąstymą bei suprasti, kur matematika naudojama realiame gyvenime.',
      },
      {
        title: 'Kaip pasirinkti matematikos žaidimą vaikui?',
        text:
          'Geriausia pradėti nuo temos ir sudėtingumo, kurie atitinka dabartinius vaiko gebėjimus. Jei vaikui dar sunku skaičiuoti, verta rinktis skaičių ir pagrindinių veiksmų užduotis. Geriau skaičiuojantiems vaikams galima pasiūlyti lygtis, trupmenas, laiką, pinigus, geometriją ar logines užduotis. Svarbiausia, kad užduotis būtų pakankamai įdomi ir kartu suteiktų galimybę mokytis.',
      },
    ],
    faq: [
      {
        question: 'Kokių matematikos žaidimų yra SmartPanda?',
        answer:
          'Kataloge yra skaičių, matematinių lygčių, skaičių tiesės, trupmenų, daugybos, pinigų, laiko, geometrijos, grafikų ir kitų matematikos žaidimų.',
      },
      {
        question: 'Ar matematikos galima mokytis žaidžiant?',
        answer:
          'Taip. Interaktyvios užduotys leidžia praktikuoti matematinius veiksmus ir loginį mąstymą žaidybinėje aplinkoje.',
      },
      {
        question: 'Ar žaidimai tinka skirtingo pasirengimo vaikams?',
        answer:
          'SmartPanda kataloge yra skirtingo tipo ir sudėtingumo užduočių, todėl galima rinktis pagal vaiko mokymosi poreikius.',
      },
    ],
  },

  reading: {
    path: '/skaitymo-zaidimai',
    eyebrow: 'SKAITYMO ŽAIDIMAI',
    title: 'Skaitymo žaidimai vaikams – SmartPanda',
    description:
      'Skaitymo žaidimai vaikams: žodžiai, pasakojimai, veikėjai, teksto supratimas, žodžių paieška ir kūrybinės skaitymo užduotys.',
    h1: 'Skaitymo žaidimai vaikams',
    intro:
      'Skaitymo įgūdžius galima lavinti ne tik skaitant tekstus. SmartPanda skaitymo žaidimai kviečia dėlioti žodžius, suprasti pasakojimus, ieškoti žodžių, atpažinti veikėjus ir kurti istorijas.',
    about: [
      'skaitymo žaidimai vaikams',
      'skaitymo įgūdžiai',
      'teksto supratimas',
      'žodynas',
      'pasakojimo supratimas',
    ],
    learningOutcomes: [
      'Žodyno plėtimas',
      'Skaitymo ir teksto supratimo lavinimas',
      'Pasakojimo struktūros supratimas',
      'Žodžių ir sakinių sudarymo praktika',
      'Dėmesio bei informacijos paieškos įgūdžiai',
    ],
    contentSections: [
      {
        title: 'Žodžiai ir sakiniai',
        text:
          'Vaikai gali dėlioti žodžius, kurti sakinius, ieškoti žodžių ir mokytis pastebėti kalbos struktūrą.',
      },
      {
        title: 'Pasakojimų supratimas',
        text:
          'Pasakojimų sekos, veikėjų paieška ir teksto supratimo užduotys padeda mokytis sekti istoriją ir suprasti pagrindinę informaciją.',
      },
      {
        title: 'Skaitymas kaip nuotykis',
        text:
          'Žaidybiniai scenarijai paverčia skaitymo užduotis aktyvia veikla – vaikas ne tik skaito, bet ir ieško, dėlioja bei sprendžia.',
      },
    ],
    faq: [
      {
        question: 'Ką lavina skaitymo žaidimai?',
        answer:
          'Jie gali padėti lavinti žodyną, skaitymo sklandumą, teksto supratimą, dėmesį ir gebėjimą sekti pasakojimo struktūrą.',
      },
      {
        question: 'Ar yra žaidimų su pasakojimais?',
        answer:
          'Taip. Kataloge yra pasakojimo sekos, teksto supratimo, veikėjų ir istorijų kūrimo žaidimų.',
      },
      {
        question: 'Ar skaitymo žaidimai skirti tik pradedantiesiems?',
        answer:
          'Ne. Kategorijoje yra įvairaus tipo užduočių – nuo žodžių ir sakinių sudarymo iki pasakojimo supratimo bei kūrybinių užduočių.',
      },
    ],
  },

  lithuanian: {
    path: '/lietuviu-kalbos-zaidimai',
    eyebrow: 'LIETUVIŲ KALBOS ŽAIDIMAI',
    title: 'Lietuvių kalbos žaidimai vaikams – SmartPanda',
    description:
      'Lietuvių kalbos žaidimai vaikams: abėcėlė, skiemenys, žodžiai, sakiniai, balsės, priebalsės, skyryba ir kalbos užduotys.',
    h1: 'Lietuvių kalbos žaidimai vaikams',
    intro:
      'SmartPanda lietuvių kalbos žaidimai padeda vaikams žaismingai praktikuoti raides, skiemenis, žodžius, sakinius, balses, priebalses, skyrybą ir kitus kalbos pagrindus.',
    about: [
      'lietuvių kalbos žaidimai',
      'raidžių mokymasis',
      'skiemenys',
      'žodžių sudarymas',
      'sakinių sudarymas',
      'skyryba',
    ],
    learningOutcomes: [
      'Raidžių ir abėcėlės pažinimas',
      'Skiemenų ir žodžio struktūros supratimas',
      'Žodyno ir žodžių ryšių plėtimas',
      'Sakinių sudarymo įgūdžiai',
      'Balsių ir priebalsių atpažinimas',
      'Didžiųjų raidžių ir skyrybos praktika',
      'Skaitymo bei kalbinės raiškos lavinimas',
    ],
    childLinks: [
      { path: '/zodynas', name: 'Žodynas' },
      { path: '/teksto-supratimas', name: 'Teksto supratimas' },
    ],
    relatedLinks: [
      {
        path: '/mokymosi-gidai/kaip-mokyti-vaika-skaityti',
        name: 'Kaip mokyti vaiką skaityti?',
      },
    ],
    contentSections: [
      {
        title: 'Raidės ir abėcėlė',
        text:
          'Raidžių ir abėcėlės užduotys padeda vaikui atpažinti raides, suprasti jų vietą abėcėlėje ir susieti raides su žodžiais. Žaidybinė praktika leidžia dažnai kartoti pagrindus trumpomis ir aiškiomis užduotimis.',
      },
      {
        title: 'Skiemenys ir žodžių struktūra',
        text:
          'Skiemuo yra svarbi grandis tarp atskirų garsų, raidžių ir viso žodžio. Skiemenų užduotys padeda vaikui pastebėti žodžio dalis, geriau suprasti jo struktūrą ir palaipsniui pereiti prie sudėtingesnių žodžių.',
      },
      {
        title: 'Žodynas ir žodžių ryšiai',
        text:
          'Žodžių sudarymo, rimų, žodžių šeimų ir žodžių paieškos užduotys leidžia plėsti žodyną bei pastebėti, kaip žodžiai susiję tarpusavyje. Vaikas ne tik atpažįsta žodžius, bet ir praktiškai juos naudoja skirtingose kalbinėse situacijose.',
      },
      {
        title: 'Sakiniai ir kalbos struktūra',
        text:
          'Sakinių sudarymo užduotys padeda suprasti, kaip atskiri žodžiai susijungia į prasmingą sakinį. Dėliodamas žodžius tinkama tvarka vaikas praktiškai lavina sakinio struktūros ir kalbinės raiškos įgūdžius.',
      },
      {
        title: 'Balsės, priebalsės ir kalbos garsai',
        text:
          'Balsių ir priebalsių atpažinimo užduotys padeda geriau suprasti lietuvių kalbos raidžių grupes. Kartu su skiemenų ir rimų veiklomis jos suteikia daugiau progų lavinti fonologinį suvokimą bei kalbinį dėmesį.',
      },
      {
        title: 'Rašyba ir skyryba',
        text:
          'Didžiųjų raidžių ir skyrybos užduotys leidžia praktiškai taikyti kalbos taisykles. Vaikas mokosi pastebėti, kur tekste reikalinga didžioji raidė, atpažinti skyrybos vietas ir analizuoti sakinius.',
      },
      {
        title: 'Skaitymas, kūrybinė kalba ir argumentavimas',
        text:
          'Lietuvių kalbos mokymasis nesibaigia raidžių ar taisyklių atpažinimu. Skaitymo, kūrybinio rašymo ir argumentavimo užduotys padeda vaikui suprasti tekstą, kurti savo mintis, plėsti kalbinę raišką ir mokytis pagrįsti nuomonę.',
      },
    ],
    faq: [
      {
        question: 'Ką galima mokytis su lietuvių kalbos žaidimais?',
        answer:
          'Vaikai gali praktikuoti abėcėlę, skiemenis, žodžius, sakinius, balses, priebalses, didžiąsias raides, skyrybą ir kitus kalbos įgūdžius.',
      },
      {
        question: 'Ar žaidimai padeda mokytis lietuvių kalbos pagrindų?',
        answer:
          'Taip. Žaidybinės užduotys suteikia galimybę praktiškai kartoti ir taikyti kalbos pagrindus.',
      },
      {
        question: 'Ar yra žodžių ir sakinių kūrimo užduočių?',
        answer:
          'Taip. Kataloge yra žodžių sudarymo, sakinių sudarymo, žodžių šeimos ir kitų kalbos užduočių.',
      },
    ],
  },

  speech: {
    path: '/logopediniai-zaidimai',
    eyebrow: 'KALBOS IR TARIMO ŽAIDIMAI',
    title: 'Logopediniai žaidimai vaikams – SmartPanda',
    description:
      'Interaktyvūs kalbos ir tarimo žaidimai vaikams: skiemenys, garsai, minimalios poros, tarimo užduotys ir kalbiniai iššūkiai.',
    h1: 'Logopediniai žaidimai vaikams',
    intro:
      'SmartPanda turi interaktyvių kalbos ir tarimo užduočių, kurios padeda žaismingai praktikuoti skiemenis, garsus, žodžius, klausymąsi ir kalbos įgūdžius.',
    about: [
      'kalbos lavinimas',
      'kalbos garsai',
      'skiemenys',
      'garso atpažinimas',
      'kalbinis dėmesys',
    ],
    learningOutcomes: [
      'Skiemens struktūros ir ritmo lavinimas',
      'Kalbos garsų atpažinimo praktika',
      'Garsų vietos žodyje nustatymas',
      'Žodžių ir garsų skyrimas',
      'Kalbinio dėmesio ir atminties lavinimas',
    ],
    contentSections: [
      {
        title: 'Skiemenys ir kalbos ritmas',
        text:
          'Skiemenų rūšiavimo ir plojimo užduotys leidžia vaikui aktyviai tyrinėti žodžių struktūrą ir kalbos ritmą.',
      },
      {
        title: 'Garsų paieška',
        text:
          'Garsų paieškos ir jų vietos žodyje užduotys padeda lavinti gebėjimą klausytis, atpažinti ir skirti kalbos garsus.',
      },
      {
        title: 'Žaisminga kalbos praktika',
        text:
          'Kalbiniai iššūkiai, žodžių žaidimai ir atminties užduotys padeda kalbos praktiką paversti trumpomis, aktyviomis veiklomis.',
      },
    ],
    faq: [
      {
        question: 'Kokie žaidimai yra logopedinių žaidimų kategorijoje?',
        answer:
          'Kategorijoje yra skiemenų, garsų, minimalių porų, kvėpavimo, garsų vietos ir kitų kalbos įgūdžius lavinančių žaidimų.',
      },
      {
        question: 'Ar SmartPanda yra logopedinė medicininė priemonė?',
        answer:
          'Ne. SmartPanda pateikia edukacines ir praktines kalbos užduotis. Jos nepakeičia logopedo, gydytojo ar individualaus specialistų įvertinimo.',
      },
      {
        question: 'Ar kalbos žaidimai gali būti naudojami namuose?',
        answer:
          'Taip. Jie gali būti naudojami kaip papildoma edukacinė veikla namuose ar mokymosi procese.',
      },
    ],
  },
};


const getGamesByTopic = (topic) =>
  SEO_GAME_CATALOG.filter(
    (game) => Array.isArray(game.topics) && game.topics.includes(topic)
  );


/*
 * STAGE 7 — AGE SEO HUBS
 *
 * These are broad learning-stage hubs, not exact-age/class doorway pages.
 * Classification is based on the existing SEO game suitability metadata.
 */

const AGE_HUB_EXTRA_PRESCHOOL_IDS = new Set([
  'breathing_dragon',
  'sound_position_finder',
  'emotion_charades',
  'shape_yoga',
]);

const AGE_HUB_EXTRA_PRIMARY_IDS = new Set([
  'tongue_twister_challenge',
  'minimal_pairs_memory',
  'sight_word_bingo',
  'note_name',
  'ai_coding_blocks',
  'dream_builder',
  'kuciu_stalas',
]);

const getGameDetails = (gameSlug) =>
  SEO_GAME_DETAILS?.[gameSlug] || null;

const getGamesByAgeHub = (ageHub) => {
  if (ageHub === 'preschool') {
    return SEO_GAME_CATALOG.filter((game) => {
      const details = getGameDetails(game.slug);
      const suitableFor = String(details?.suitableFor || '').toLowerCase();

      return (
        suitableFor.includes('ikimokyklinio') ||
        AGE_HUB_EXTRA_PRESCHOOL_IDS.has(game.id)
      );
    });
  }

  if (ageHub === 'primary') {
    return SEO_GAME_CATALOG.filter((game) => {
      const details = getGameDetails(game.slug);
      const suitableFor = String(details?.suitableFor || '').toLowerCase();

      return (
        suitableFor.includes('pradinio') ||
        AGE_HUB_EXTRA_PRIMARY_IDS.has(game.id)
      );
    });
  }

  return [];
};

const AGE_HUB_CONFIG = {
  preschool: {
    path: '/zaidimai-ikimokyklinukams',
    eyebrow: 'MOKOMIEJI ŽAIDIMAI IKIMOKYKLINUKAMS',
    title: 'Mokomieji žaidimai ikimokyklinukams | SmartPanda',
    description:
      'Mokomieji žaidimai ikimokyklinukams: spalvos, formos, skaičiai, kalba, sekos, dėmesys ir kitos žaismingos užduotys vaikams.',
    h1: 'Mokomieji žaidimai ikimokyklinukams',
    intro:
      'Žaismingos interaktyvios užduotys jaunesniems vaikams: spalvų ir formų pažinimas, pirmieji skaičiai, sekos, kalbos užduotys, dėmesys ir kiti mokymosi pagrindai.',
    about: [
      'SmartPanda ikimokyklinukams skirti žaidimai orientuoti į ankstyvojo mokymosi užduotis, kuriose vaikas gali pažinti spalvas, formas, skaičius, žodžius, sekas ir atlikti trumpas interaktyvias užduotis.',
      'Šiame puslapyje pateikiami žaidimai parinkti pagal esamą SmartPanda žaidimų aprašymuose nurodytą tinkamumą ikimokyklinio amžiaus vaikams ir papildomai įtrauktos kelios temos, kurių pobūdis tinkamas jaunesniems vaikams.',
    ],
    learningOutcomes: [
      'Spalvų ir formų pažinimas',
      'Pirmųjų skaičių ir sekų praktika',
      'Žodžių, garsų ir kalbos pagrindų pažinimas',
      'Dėmesio ir taisyklių laikymosi praktika',
      'Loginio mąstymo pradmenys',
    ],
    contentSections: [
      {
        title: 'Kaip mokytis ikimokykliniame amžiuje žaidžiant?',
        paragraphs: [
          'Ikimokyklinio amžiaus vaikams naudingos trumpos ir aiškios užduotys, kuriose galima veikti, bandyti ir iš karto matyti rezultatą. Spalvų, formų, skaičių, sekų ir žodžių užduotys leidžia mokymąsi susieti su aktyvia veikla.',
          'Žaidimus verta rinktis pagal vaiko gebėjimus ir palaipsniui didinti užduočių sudėtingumą.',
        ],
      },
      {
        title: 'Spalvos, formos ir pirmieji skaičiai',
        paragraphs: [
          'Ankstyvajame mokymesi svarbu ne tik įsiminti pavadinimus, bet ir juos atpažinti bei susieti su konkrečiais objektais. Interaktyvios rūšiavimo, derinimo ir skaičių užduotys leidžia tai praktikuoti.',
        ],
      },
      {
        title: 'Kalbos ir žodžių pažinimas',
        paragraphs: [
          'Kalbos užduotys gali būti derinamos su kasdieniu pokalbiu, paveikslėlių aptarimu ir skaitymu. Žaidimai leidžia papildomai praktikuoti raides, skiemenis, garsus ir paprastus žodžius.',
        ],
      },
      {
        title: 'Trumpi žaidimai ir dėmesio praktika',
        paragraphs: [
          'Jaunesniems vaikams patogu mokytis trumpais etapais. Užduotys, kuriose reikia pastebėti spalvą, formą, garsą ar laikytis paprastos taisyklės, leidžia praktikuoti susikaupimą žaidybinėje aplinkoje.',
        ],
      },
      {
        title: 'Kaip pasirinkti tinkamą žaidimą?',
        paragraphs: [
          'Pradėkite nuo užduočių, kurias vaikas supranta be sudėtingų paaiškinimų. Kai jos tampa lengvos, galima rinktis daugiau elementų ar sudėtingesnę taisyklę turinčius žaidimus.',
        ],
      },
    ],
    faq: [
      {
        question: 'Kokio amžiaus vaikams skirti šie žaidimai?',
        answer:
          'Šis puslapis skirtas ikimokyklinio amžiaus vaikams, maždaug 4–6 metų tarpsniui. Konkretus tinkamumas priklauso nuo vaiko gebėjimų ir pasirinkto žaidimo sudėtingumo.',
      },
      {
        question: 'Ką ikimokyklinukai gali mokytis žaisdami?',
        answer:
          'Vaikai gali praktikuoti spalvų ir formų pažinimą, pirmuosius skaičiavimo įgūdžius, sekas, žodžius, garsus, dėmesį ir kitus ankstyvojo mokymosi įgūdžius.',
      },
      {
        question: 'Ar visi žaidimai vienodai tinkami jaunesniems vaikams?',
        answer:
          'Ne. Žaidimų sudėtingumas skiriasi, todėl rekomenduojama rinktis pagal vaiko gebėjimus ir pradėti nuo aiškesnių, trumpesnių užduočių.',
      },
    ],
    relatedLinks: [
      {
        path: '/zaidimai-pradinukams',
        name: 'Mokomieji žaidimai pradinukams',
      },
      {
        path: '/mokomieji-zaidimai',
        name: 'Visi mokomieji žaidimai',
      },
      {
        path: '/loginis-mastymas',
        name: 'Loginio mąstymo žaidimai',
      },
      {
        path: '/zodynas',
        name: 'Žodyno žaidimai',
      },
    ],
  },

  primary: {
    path: '/zaidimai-pradinukams',
    eyebrow: 'MOKOMIEJI ŽAIDIMAI PRADINUKAMS',
    title: 'Mokomieji žaidimai pradinukams | SmartPanda',
    description:
      'Mokomieji žaidimai pradinukams: matematika, skaitymas, lietuvių kalba, loginis mąstymas, gamtos mokslai ir kitos užduotys.',
    h1: 'Mokomieji žaidimai pradinukams',
    intro:
      'Interaktyvūs žaidimai pradinio mokyklinio amžiaus vaikams: matematika, skaitymas, lietuvių kalba, loginis mąstymas, gamtos mokslai, kūryba ir praktinės užduotys.',
    about: [
      'SmartPanda pradinukams skirti žaidimai apima pagrindines mokymosi sritis: skaičius ir matematiką, skaitymą, lietuvių kalbą, loginį mąstymą, gamtos mokslus ir kitas edukacines temas.',
      'Žaidimų kolekcija parinkta pagal esamą SmartPanda SEO aprašymuose nurodytą tinkamumą pradinio mokyklinio amžiaus vaikams, papildant ją keliomis aiškiai pradinukams tinkamomis temomis.',
    ],
    learningOutcomes: [
      'Matematinių ir skaičiavimo įgūdžių praktika',
      'Skaitymo ir teksto supratimo lavinimas',
      'Žodyno ir lietuvių kalbos įgūdžių stiprinimas',
      'Loginio ir problemų sprendimo mąstymo praktika',
      'Gamtos mokslų, geografijos ir kitų temų pažinimas',
    ],
    contentSections: [
      {
        title: 'Mokymasis pradinėse klasėse per žaidimą',
        paragraphs: [
          'Pradinukams svarbu daug praktikuotis ir taikyti žinias skirtingose situacijose. Interaktyvūs žaidimai leidžia spręsti užduotis, gauti grįžtamąjį ryšį ir pakartoti sudėtingesnes temas.',
          'Žaidimus galima rinktis pagal mokomąją sritį ir vaiko pasirengimo lygį.',
        ],
      },
      {
        title: 'Matematika, skaičiai ir problemų sprendimas',
        paragraphs: [
          'Pradinukams skirtose užduotyse galima praktikuoti skaičiavimą, lygtis, trupmenas, daugybą, pinigus, laiką, geometriją ir matematinius galvosūkius.',
        ],
      },
      {
        title: 'Skaitymas, žodynas ir lietuvių kalba',
        paragraphs: [
          'Kalbos ir skaitymo žaidimai leidžia dėlioti žodžius bei sakinius, suprasti pasakojimus, atpažinti kalbos struktūras ir praktikuoti žodyną.',
        ],
      },
      {
        title: 'Loginis mąstymas ir įvairių temų pažinimas',
        paragraphs: [
          'Loginės užduotys gali būti susietos su skaičiais, formomis, pasakojimais ar kitomis temomis. Kiti žaidimai leidžia tyrinėti gamtą, geografiją, istoriją, muziką ir kūrybines užduotis.',
        ],
      },
      {
        title: 'Kaip pasirinkti žaidimą pradinukui?',
        paragraphs: [
          'Geriausia pradėti nuo temos, kurią vaikas šiuo metu mokosi, ir pasirinkti užduotį pagal jo gebėjimus. Jei užduotis per lengva, galima rinktis sudėtingesnį iššūkį; jei per sunki, verta grįžti prie pagrindų.',
        ],
      },
    ],
    faq: [
      {
        question: 'Kokio amžiaus vaikams skirti šie žaidimai?',
        answer:
          'Šis puslapis skirtas pradinio mokyklinio amžiaus vaikams, maždaug 6–10 metų tarpsniui. Konkretus tinkamumas priklauso nuo vaiko gebėjimų ir žaidimo sudėtingumo.',
      },
      {
        question: 'Kokių dalykų gali mokytis pradinukas?',
        answer:
          'SmartPanda kataloge yra matematikos, skaitymo, lietuvių kalbos, loginio mąstymo, gamtos mokslų, geografijos, istorijos, muzikos, kūrybinių ir kitų edukacinių užduočių.',
      },
      {
        question: 'Ar galima rinktis skirtingo sudėtingumo žaidimus?',
        answer:
          'Taip. Kataloge yra skirtingo tipo užduočių, todėl galima pradėti nuo pagrindinių įgūdžių ir pereiti prie sudėtingesnių užduočių pagal vaiko pasirengimą.',
      },
    ],
    relatedLinks: [
      {
        path: '/zaidimai-ikimokyklinukams',
        name: 'Mokomieji žaidimai ikimokyklinukams',
      },
      {
        path: '/mokomieji-zaidimai',
        name: 'Visi mokomieji žaidimai',
      },
      {
        path: '/matematikos-zaidimai',
        name: 'Matematikos žaidimai',
      },
      {
        path: '/skaitymo-zaidimai',
        name: 'Skaitymo žaidimai',
      },
      {
        path: '/lietuviu-kalbos-zaidimai',
        name: 'Lietuvių kalbos žaidimai',
      },
    ],
  },
};

const TOPIC_HUB_CONFIG = {
  logical: {
    path: '/loginis-mastymas',
    topic: 'Loginis mąstymas',
    eyebrow: 'Loginis mąstymas vaikams',
    title: 'Loginio mąstymo žaidimai vaikams | SmartPanda',
    description:
      'Loginio mąstymo žaidimai vaikams: sekos, dėsningumai, galvosūkiai ir problemų sprendimas mokantis žaidžiant.',
    h1: 'Loginio mąstymo žaidimai vaikams',
    intro:
      'Interaktyvūs loginio mąstymo žaidimai padeda vaikams mokytis pastebėti dėsningumus, lyginti informaciją, kurti sekas ir ieškoti sprendimų.',
    about: [
      'Loginis mąstymas vaikams lavėja tada, kai reikia ne tik prisiminti atsakymą, bet ir suprasti ryšį tarp skirtingų objektų, veiksmų ar taisyklių.',
      'SmartPanda temoje „Loginis mąstymas“ surinkti žaidimai leidžia praktiškai išbandyti sekų kūrimą, rūšiavimą, dėsningumų atpažinimą ir įvairius galvosūkius.',
    ],
    learningOutcomes: [
      'Atpažinti dėsningumus ir pasikartojančius modelius',
      'Sukurti ir tęsti logines sekas',
      'Rūšiuoti objektus pagal jų savybes',
      'Ieškoti sprendimo kelių ir tikrinti savo pasirinkimus',
    ],
    contentSections: [
      {
        title: 'Kaip lavinti loginį mąstymą žaidžiant?',
        paragraphs: [
          'Geriausia pradėti nuo užduočių, kuriose vaikas gali aiškiai matyti taisyklę ir pats išbandyti sprendimą. Sekos, rūšiavimo ir dėsningumų užduotys suteikia greitą grįžtamąjį ryšį.',
          'Sudėtingumą galima palaipsniui didinti: nuo paprastų vizualinių modelių iki užduočių, kuriose reikia derinti kelias informacijos dalis.',
        ],
      },
      {
        title: 'Kokias logines užduotis gali atlikti vaikas?',
        paragraphs: [
          'Loginio mąstymo žaidimuose vaikas gali tęsti sekas, atrasti trūkstamą elementą, grupuoti objektus pagal bendras savybes, palyginti skirtingus variantus ar pasirinkti taisyklę atitinkantį atsakymą.',
          'Tokios užduotys skatina ne tik rasti atsakymą, bet ir atkreipti dėmesį į tai, kodėl vienas pasirinkimas tinka, o kitas – ne. Tai padeda mokytis nuosekliai tikrinti savo sprendimus.',
        ],
      },
      {
        title: 'Kaip pasirinkti tinkamą sudėtingumą?',
        paragraphs: [
          'Jaunesniems vaikams dažniausiai patogiau pradėti nuo aiškių paveikslėlių, spalvų, formų ir trumpų sekų. Kai taisyklę pavyksta lengvai atpažinti, galima pereiti prie užduočių su daugiau elementų arba keliomis sąlygomis.',
          'Svarbu išlaikyti užduotį įveikiamą, bet ne visiškai automatinę. Jei vaikas dažnai suklysta, verta grįžti prie paprastesnio varianto; jei užduotis išsprendžiama be jokio mąstymo, galima ieškoti sudėtingesnio iššūkio.',
        ],
      },
      {
        title: 'Loginis mąstymas ir kitos mokymosi sritys',
        paragraphs: [
          'Loginiai įgūdžiai pritaikomi ne tik galvosūkiuose. Jie padeda suprasti matematines sekas, palyginti skaičius, pastebėti kalbos dėsningumus, susieti informaciją skaitant ir planuoti kelių veiksmų sprendimą.',
          'Dėl to loginio mąstymo žaidimus galima derinti su matematikos, skaičių, skaitymo ir lietuvių kalbos užduotimis. Įvairios veiklos leidžia tą patį mąstymo įgūdį pritaikyti skirtingame kontekste.',
        ],
      },
      {
        title: 'Kam tinka šie žaidimai?',
        paragraphs: [
          'Šie žaidimai tinka vaikams, kurie mokosi pastebėti ryšius, planuoti veiksmus ir spręsti įvairaus tipo galvosūkius.',
          'Temą galima derinti su matematikos, skaičių ir skaitymo žaidimais, nes loginio mąstymo įgūdžiai pritaikomi skirtingose mokymosi srityse.',
        ],
      },
    ],
    faq: [
      {
        question: 'Kas yra loginio mąstymo žaidimai vaikams?',
        answer:
          'Tai interaktyvios užduotys, kuriose vaikas turi pastebėti ryšius, taisykles, sekas, skirtumus arba pasirinkti tinkamą sprendimą.',
      },
      {
        question: 'Kokius įgūdžius lavina loginio mąstymo žaidimai?',
        answer:
          'Žaidimai gali padėti praktikuoti dėsningumų atpažinimą, sekų kūrimą, rūšiavimą, problemų sprendimą ir informacijos palyginimą.',
      },
      {
        question: 'Ar loginio mąstymo žaidimai susiję su matematika?',
        answer:
          'Taip, kai kurios loginės užduotys naudoja skaičius ir matematinius ryšius, tačiau loginį mąstymą galima lavinti ir su formomis, žodžiais bei kitais objektais.',
      },
    ],
    relatedLinks: [
      { path: '/mokomieji-zaidimai', name: 'Mokomieji žaidimai' },
      { path: '/skaitymo-zaidimai', name: 'Skaitymo žaidimai' },
      { path: '/lietuviu-kalbos-zaidimai', name: 'Lietuvių kalbos žaidimai' },
      {
        path: '/logopediniai-zaidimai',
        name: 'Logopediniai ir kalbos lavinimo žaidimai',
      },
    ],
  },

  numbers: {
    path: '/skaiciai-ir-skaiciavimas',
    topic: 'Skaičiai ir skaičiavimas',
    eyebrow: 'Skaičiai ir skaičiavimas',
    title: 'Skaičių ir skaičiavimo žaidimai vaikams | SmartPanda',
    description:
      'Skaičių ir skaičiavimo žaidimai vaikams: skaičių atpažinimas, sekos, skaičių tiesė ir matematiniai galvosūkiai.',
    h1: 'Skaičių ir skaičiavimo žaidimai vaikams',
    intro:
      'Žaidimai, skirti skaičių pažinimui, skaičiavimui, skaičių sekoms ir praktiniam matematinių ryšių supratimui.',
    about: [
      'Skaičių mokymasis tampa aiškesnis, kai vaikas gali skaičiuoti, lyginti ir atlikti užduotis interaktyvioje aplinkoje.',
      'Ši teminė kolekcija orientuota į skaičius ir skaičiavimą, todėl papildo platesnę SmartPanda matematikos žaidimų kategoriją.',
    ],
    learningOutcomes: [
      'Atpažinti ir susieti skaičius',
      'Tęsti skaičių sekas',
      'Orientuotis skaičių tiesėje',
      'Praktikuoti skaičiavimo ir matematinių ryšių supratimą',
    ],
    contentSections: [
      {
        title: 'Kaip mokytis skaičiuoti žaidžiant?',
        paragraphs: [
          'Skaičiavimo įgūdžius naudinga praktikuoti trumpomis, aiškiomis užduotimis. Vaikas gali pradėti nuo skaičių atpažinimo ir pereiti prie sekų bei skaičių ryšių.',
          'Interaktyvus grįžtamasis ryšys leidžia iš karto pamatyti pasirinkimo rezultatą ir pakartoti užduotį.',
        ],
      },
      {
        title: 'Skaičiai kasdienėse situacijose',
        paragraphs: [
          'Skaičiavimas naudojamas ne tik pamokose. Skaičiai pasitaiko žaidžiant, planuojant laiką, apsiperkant ir sprendžiant kasdienes užduotis.',
          'Todėl skaičių žaidimus verta derinti su kitomis matematikos temomis, pavyzdžiui, pinigais, laiku ir aritmetika.',
        ],
      },
      {
        title: 'Kaip vaikui mokytis skaičiuoti nuo paprastų užduočių?',
        paragraphs: [
          'Mokantis skaičiuoti naudinga pradėti nuo užduočių, kuriose vaikas gali susieti skaičių su konkrečiu objektų kiekiu. Pavyzdžiui, galima skaičiuoti paveikslėlyje esančius daiktus, parinkti tinkamą skaičių arba sudėlioti objektus pagal jų kiekį.',
          'Kai pagrindiniai skaičiavimo veiksmai tampa aiškesni, galima pereiti prie didesnių skaičių, sekų ir užduočių, kuriose reikia palyginti kelis variantus. Trumpi žaidimai leidžia dažnai kartoti įgūdį ir iš karto pamatyti pasirinkimo rezultatą.',
        ],
      },
      {
        title: 'Kaip skaičių žaidimai padeda suprasti skaičių ryšius?',
        paragraphs: [
          'Skaičius svarbu ne tik atpažinti, bet ir suprasti jų tarpusavio ryšius. Vaikas gali mokytis, kuris skaičius yra didesnis ar mažesnis, kas eina prieš arba po tam tikro skaičiaus ir kaip skaičiai keičiasi tam tikra tvarka.',
          'Tokios užduotys padeda pereiti nuo vien tik skaičių įsiminimo prie jų naudojimo sprendžiant konkrečias užduotis. Interaktyvus formatas leidžia tą patį ryšį išbandyti kelis kartus skirtinguose pavyzdžiuose.',
        ],
      },
      {
        title: 'Skaičių tiesė, sekos ir skaičių palyginimas',
        paragraphs: [
          'Skaičių tiesė padeda vaikui vizualiai suprasti skaičių tvarką ir atstumą tarp jų. Užduotys su skaičių tiese gali būti naudojamos ieškant trūkstamo skaičiaus, nustatant skaičiaus vietą arba judant pirmyn ir atgal pagal nurodytą taisyklę.',
          'Skaičių sekos ir palyginimo užduotys papildo šį mokymąsi. Vaikas gali pratęsti seką, surasti taisyklę, palyginti skaičius ir patikrinti, ar jo pasirinkimas atitinka pateiktą sąlygą.',
        ],
      },
    ],
    faq: [
      {
        question: 'Ką vaikai mokosi atlikdami skaičių žaidimus?',
        answer:
          'Vaikai gali praktikuoti skaičių atpažinimą, skaičiavimą, sekų supratimą, skaičių palyginimą ir kitus pagrindinius matematinius ryšius.',
      },
      {
        question: 'Kuo skiriasi ši tema nuo matematikos žaidimų kategorijos?',
        answer:
          'Matematikos kategorija yra platesnė, o ši teminė kolekcija daugiausia skirta skaičiams, skaičiavimui, sekoms ir su skaičiais susijusioms užduotims.',
      },
      {
        question: 'Kaip vaikui pradėti mokytis skaičiuoti žaidžiant?',
        answer:
          'Verta pradėti nuo skaičių atpažinimo ir paprasto skaičiavimo, o užduočių sudėtingumą didinti vaikui jau užtikrintai atliekant ankstesnes užduotis.',
      },
    ],
    relatedLinks: [
      { path: '/matematikos-zaidimai', name: 'Matematikos žaidimai' },
      { path: '/loginis-mastymas', name: 'Loginis mąstymas' },
      {
        path: '/mokymosi-gidai/kaip-ismokyti-vaika-skaiciuoti',
        name: 'Kaip išmokyti vaiką skaičiuoti?',
      },
    ],
  },

  vocabulary: {
    path: '/zodynas',
    topic: 'Žodynas',
    eyebrow: 'Žodynas vaikams',
    title: 'Žodyno lavinimo žaidimai vaikams | SmartPanda',
    description:
      'Žodyno lavinimo žaidimai vaikams: žodžių sudarymas, rimai, žodžių šeimos ir žodžių paieška.',
    h1: 'Žodyno lavinimo žaidimai vaikams',
    intro:
      'Interaktyvūs žaidimai padeda vaikams susipažinti su žodžiais, jų reikšmėmis, ryšiais ir kalbos struktūra.',
    about: [
      'Žodynas plečiamas nuolat susiduriant su naujais žodžiais ir naudojant juos skirtinguose kontekstuose.',
      'SmartPanda žodyno žaidimuose vaikas gali sudaryti žodžius, ieškoti žodžių, atpažinti rimus ir tyrinėti žodžių šeimas.',
    ],
    learningOutcomes: [
      'Plėsti aktyviai naudojamų žodžių žodyną',
      'Sudaryti žodžius iš pateiktų dalių',
      'Atpažinti panašiai skambančius žodžius ir rimus',
      'Pastebėti žodžių tarpusavio ryšius',
    ],
    contentSections: [
      {
        title: 'Kaip plėsti vaiko žodyną žaidžiant?',
        paragraphs: [
          'Žodžius lengviau įsiminti tada, kai jie naudojami atliekant konkrečią užduotį. Žodžių paieška, sudarymas ir grupavimas leidžia vaikui aktyviai su jais dirbti.',
          'Žaidimus verta derinti su skaitymu ir pokalbiais, kad nauji žodžiai būtų naudojami ne tik žaidimo metu.',
        ],
      },
      {
        title: 'Žodžiai, garsai ir kalbos struktūra',
        paragraphs: [
          'Žodyno mokymasis glaudžiai susijęs su kitais kalbos įgūdžiais. Žodžių struktūros, skiemenų ir garsų užduotys gali papildyti žodyno praktiką.',
        ],
      },
      {
        title: 'Kaip vaikui lengviau išmokti naujų žodžių?',
        paragraphs: [
          'Naujus žodžius vaikui lengviau įsiminti tada, kai jie pateikiami aiškiame kontekste ir naudojami atliekant konkrečią užduotį. Paveikslėlių, žodžių paieškos, sudarymo ir grupavimo veiklos leidžia susieti naują žodį su jo reikšme.',
          'Naudinga tą patį žodį sutikti kelis kartus skirtingose situacijose. Žaidimą galima papildyti pokalbiu, skaitymu ar trumpais sakiniais, kuriuose vaikas pats pavartoja išmoktą žodį.',
        ],
      },
      {
        title: 'Kaip suprasti žodžių reikšmes ir jų ryšius?',
        paragraphs: [
          'Žodyno lavinimas apima ne tik naujų žodžių įsiminimą. Vaikui svarbu pastebėti, kuo žodžiai panašūs ar skiriasi, kurie žodžiai priklauso tai pačiai grupei ir kaip jų reikšmė keičiasi priklausomai nuo sakinio.',
          'Tokios užduotys padeda mokytis klasifikuoti žodžius, ieškoti jų tarpusavio ryšių ir pasirinkti tinkamą žodį pagal pateiktą situaciją.',
        ],
      },
      {
        title: 'Žodynas, skaitymas ir sakinių kūrimas',
        paragraphs: [
          'Geresnis žodyno pažinimas padeda suprasti skaitomą tekstą ir tiksliau išreikšti mintis. Skaitydami vaikai susiduria su naujais žodžiais, o žodyno užduotys leidžia juos papildomai praktikuoti.',
          'Žodžių sudarymą ir paiešką galima derinti su sakinių kūrimu. Taip vaikas mokosi ne tik atpažinti žodį, bet ir suprasti, kaip jį panaudoti prasmingame sakinyje.',
        ],
      },
    ],
    faq: [
      {
        question: 'Kam skirti žodyno žaidimai?',
        answer:
          'Žodyno žaidimai skirti vaikams, kurie nori praktikuoti žodžių atpažinimą, sudarymą, paiešką, rimus ir žodžių tarpusavio ryšius.',
      },
      {
        question: 'Ar žodyno žaidimai tinka kartu su skaitymo mokymusi?',
        answer:
          'Taip. Žodyno ir skaitymo įgūdžiai papildo vienas kitą, todėl šias temas galima praktikuoti kartu.',
      },
      {
        question: 'Kaip tėvai gali padėti vaikui plėsti žodyną?',
        answer:
          'Naudinga kartu aptarti naujus žodžius, ieškoti jų reikšmių ir skatinti vaiką panaudoti žodžius skirtinguose sakiniuose bei žaidybinėse užduotyse.',
      },
    ],
    relatedLinks: [
      { path: '/mokomieji-zaidimai', name: 'Mokomieji žaidimai' },
      { path: '/matematikos-zaidimai', name: 'Matematikos žaidimai' },
      { path: '/skaitymo-zaidimai', name: 'Skaitymo žaidimai' },
      {
        path: '/logopediniai-zaidimai',
        name: 'Logopediniai ir kalbos lavinimo žaidimai',
      },
    ],
  },

  comprehension: {
    path: '/teksto-supratimas',
    topic: 'Teksto supratimas',
    eyebrow: 'Teksto supratimas vaikams',
    title: 'Teksto supratimo žaidimai vaikams | SmartPanda',
    description:
      'Teksto supratimo žaidimai vaikams: pasakojimo seka, veikėjai, istorijos ir skaitymo užduotys.',
    h1: 'Teksto supratimo žaidimai vaikams',
    intro:
      'Interaktyvios užduotys padeda vaikams mokytis suprasti istorijų eigą, veikėjus, įvykius ir pagrindines teksto mintis.',
    about: [
      'Teksto supratimas yra daugiau nei gebėjimas perskaityti žodžius. Vaikui svarbu suprasti, kas vyksta, kokia įvykių seka ir kaip skirtingos teksto dalys susijusios.',
      'Šioje SmartPanda temoje pateikiami žaidimai, kuriuose vaikas gali praktiškai tyrinėti istorijas, veikėjus ir pasakojimo struktūrą.',
    ],
    learningOutcomes: [
      'Atkurti pasakojimo įvykių seką',
      'Atpažinti ir apibūdinti veikėjus',
      'Susieti skirtingas istorijos dalis',
      'Atkreipti dėmesį į pagrindinę pasakojimo informaciją',
    ],
    contentSections: [
      {
        title: 'Kaip lavinti teksto supratimą?',
        paragraphs: [
          'Naudinga po skaitymo aptarti, kas įvyko pirmiausia, kas nutiko vėliau ir kodėl veikėjai elgėsi tam tikru būdu. Interaktyvios sekų ir veikėjų užduotys leidžia šiuos klausimus paversti žaidimu.',
          'Trumpi tekstai ir aiškios užduotys gali būti derinami su savarankišku skaitymu bei pokalbiu apie perskaitytą istoriją.',
        ],
      },
      {
        title: 'Teksto supratimas ir pasakojimai',
        paragraphs: [
          'Pasakojimai yra patogi aplinka praktikuoti įvykių seką, veikėjų atpažinimą ir priežasties bei pasekmės ryšius.',
        ],
      },
      {
        title: 'Kaip vaikui geriau suprasti perskaitytą tekstą?',
        paragraphs: [
          'Teksto supratimą padeda ugdyti klausimai apie tai, kas įvyko, kas buvo svarbiausia ir kaip skirtingos istorijos dalys susijusios. Vaikas gali trumpai papasakoti istoriją savais žodžiais arba pasirinkti atsakymą pagal perskaitytą informaciją.',
          'Interaktyvios užduotys leidžia šiuos veiksmus praktikuoti palaipsniui. Pradžioje galima rinktis iš kelių aiškių variantų, o vėliau pereiti prie užduočių, kuriose reikia savarankiškai susieti kelias teksto dalis.',
        ],
      },
      {
        title: 'Kaip atpažinti pagrindinę teksto mintį ir svarbiausią informaciją?',
        paragraphs: [
          'Skaitant svarbu mokytis atskirti pagrindinę informaciją nuo mažiau svarbių detalių. Vaikas gali ieškoti, apie ką daugiausia kalbama, kokia problema sprendžiama arba kuris įvykis yra svarbiausias istorijai.',
          'Tokias užduotis galima derinti su trumpais klausimais po skaitymo. Tai padeda vaikui ne tik prisiminti atskirus faktus, bet ir susidaryti bendrą supratimą apie perskaitytą tekstą.',
        ],
      },
      {
        title: 'Įvykių seka, veikėjai ir priežasties bei pasekmės ryšiai',
        paragraphs: [
          'Pasakojimo supratimą padeda stiprinti gebėjimas nustatyti, kas įvyko pirmiausia, kas nutiko vėliau ir kuo baigėsi istorija. Taip pat svarbu atpažinti veikėjus, jų veiksmus ir priežastis, dėl kurių įvykiai vystėsi tam tikra kryptimi.',
          'Rikiuodamas įvykius ar ieškodamas priežasties ir pasekmės ryšio, vaikas mokosi susieti skirtingas teksto dalis. Šie įgūdžiai praverčia tiek skaitant pasakojimus, tiek suprantant informacinį tekstą.',
        ],
      },
    ],
    faq: [
      {
        question: 'Kas yra teksto supratimo žaidimai?',
        answer:
          'Tai užduotys, kuriose vaikas turi suprasti perskaitytą ar pateiktą istoriją, jos įvykius, veikėjus ir tarpusavio ryšius.',
      },
      {
        question: 'Ar teksto supratimas susijęs su skaitymu?',
        answer:
          'Taip. Skaitymo įgūdžiai padeda suprasti tekstą, o teksto supratimo užduotys leidžia praktiškai patikrinti, kaip vaikas suprato perskaitytą informaciją.',
      },
      {
        question: 'Kaip tėvai gali padėti vaikui geriau suprasti tekstą?',
        answer:
          'Perskaičius tekstą galima kartu aptarti pagrindinę mintį, veikėjus, įvykių seką ir paklausti, kodėl istorijoje įvyko svarbiausi veiksmai.',
      },
    ],
    relatedLinks: [
      { path: '/skaitymo-zaidimai', name: 'Skaitymo žaidimai' },
      { path: '/zodynas', name: 'Žodyno žaidimai' },
      { path: '/loginis-mastymas', name: 'Loginis mąstymas' },
    ],
  },

  attention: {
    path: '/demesys',
    topic: 'Dėmesys',
    eyebrow: 'Dėmesio ir susikaupimo žaidimai',
    title: 'Dėmesio ir susikaupimo žaidimai vaikams | SmartPanda',
    description:
      'Dėmesio ir susikaupimo žaidimai vaikams: spalvų, formų, klausymo ir reakcijos užduotys mokantis žaidžiant.',
    h1: 'Dėmesio ir susikaupimo žaidimai vaikams',
    intro:
      'Interaktyvios užduotys, kuriose vaikas turi stebėti informaciją, klausytis, prisiminti taisyklę ir laiku atlikti veiksmą.',
    about: [
      'Dėmesį galima praktikuoti įvairiose situacijose: stebint spalvas ir formas, klausantis instrukcijos, prisimenant taisyklę ar reaguojant į besikeičiančią informaciją.',
      'SmartPanda šioje temoje pateikia trumpas žaidybines užduotis, kuriose svarbu sutelkti dėmesį į pateiktą informaciją ir atlikti veiksmą pagal taisyklę.',
    ],
    learningOutcomes: [
      'Atidžiai stebėti pateiktą informaciją',
      'Išklausyti ir sekti instrukcijas',
      'Prisiminti paprastą žaidimo taisyklę',
      'Greitai pastebėti informacijos pokytį ir į jį reaguoti',
    ],
    contentSections: [
      {
        title: 'Kaip praktikuoti dėmesį žaidžiant?',
        paragraphs: [
          'Dėmesio užduotys gali būti trumpos ir aiškiai apibrėžtos. Vaikas pirmiausia susipažįsta su taisykle, o tada stengiasi ją išlaikyti atlikdamas užduotį.',
          'Skirtingos užduotys leidžia keisti informacijos pateikimo būdą: naudoti spalvas, formas, garsą, judesį ar reakcijos laiką.',
        ],
      },
      {
        title: 'Skirtingi dėmesio tipai',
        paragraphs: [
          'Vienose užduotyse svarbu pastebėti vizualinę informaciją, kitose – klausytis ir sekti instrukcijas. Toks užduočių įvairumas padeda vaikui praktikuoti dėmesį skirtingose žaidimo situacijose.',
        ],
      },
      {
        title: 'Kaip vaikui lengviau išlaikyti dėmesį atliekant užduotį?',
        paragraphs: [
          'Dėmesį lengviau išlaikyti tada, kai užduotis turi aiškią taisyklę ir konkretų tikslą. Vaikas gali pradėti nuo trumpos užduoties, įsiklausyti į instrukciją ir atlikti vieną veiksmą pagal pateiktą taisyklę.',
          'Žaidžiant galima palaipsniui keisti užduoties sudėtingumą: pridėti daugiau informacijos, pakeisti taisyklę arba paprašyti vaiko atsiminti kelis veiksmus. Tokiu būdu skirtingos užduotys suteikia galimybę praktikuoti dėmesį įvairiose situacijose.',
        ],
      },
      {
        title: 'Spalvų, formų, garsų ir judesio užduotys',
        paragraphs: [
          'Dėmesį galima praktikuoti ne tik skaitant ar stebint paveikslėlius. Interaktyviuose žaidimuose vaikas gali ieškoti konkrečios spalvos ar formos, klausytis garso, sekti judantį objektą arba pasirinkti veiksmą pagal pateiktą informaciją.',
          'Skirtingi informacijos pateikimo būdai padeda keisti užduotis ir išlaikyti mokymąsi žaismingą. Vaikas mokosi pastebėti svarbią informaciją, atsirinkti ją iš kitų elementų ir tinkamai į ją sureaguoti.',
        ],
      },
      {
        title: 'Dėmesys, atmintis ir taisyklių laikymasis',
        paragraphs: [
          'Kai kuriose žaidybinėse užduotyse reikia ne tik pastebėti informaciją, bet ir prisiminti, ką reikia padaryti. Pavyzdžiui, vaikas gali išklausyti instrukciją, prisiminti žaidimo taisyklę ir tik tada pasirinkti atsakymą.',
          'Tokios užduotys natūraliai sujungia dėmesio sutelkimą, informacijos įsiminimą ir taisyklės pritaikymą. Tai leidžia vaikui praktikuoti kelis mokymuisi svarbius veiksmus vienoje aiškioje žaidimo situacijoje.',
        ],
      },
    ],
    faq: [
      {
        question: 'Kokie žaidimai padeda praktikuoti dėmesį?',
        answer:
          'Dėmesį galima praktikuoti žaidimuose, kuriuose reikia stebėti spalvas, formas, garsus, sekti instrukcijas, prisiminti taisyklę arba laiku atlikti veiksmą.',
      },
      {
        question: 'Ar šie žaidimai yra gydymas ar terapija?',
        answer:
          'Ne. Tai edukaciniai žaidimai, skirti mokymuisi ir dėmesio bei susikaupimo įgūdžių praktikai. Jie nėra medicininė diagnostikos ar gydymo priemonė.',
      },
      {
        question: 'Kaip vaikui praktikuoti dėmesį atliekant trumpas užduotis?',
        answer:
          'Galima pradėti nuo trumpų užduočių su viena aiškia taisykle, o vaikui įpratus palaipsniui ilginti veiklą arba įtraukti daugiau informacijos.',
      },
    ],
    relatedLinks: [
      { path: '/loginis-mastymas', name: 'Loginis mąstymas' },
      { path: '/mokomieji-zaidimai', name: 'Mokomieji žaidimai' },
    ],
  },

  science: {
    path: '/gamtos-mokslu-zaidimai',
    topic: 'Gamtos mokslai',
    eyebrow: 'GAMTOS MOKSLŲ ŽAIDIMAI',
    title: 'Gamtos mokslų žaidimai vaikams – SmartPanda',
    description:
      'Gamtos mokslų žaidimai vaikams: gamta, gyvūnai, orai, stebėjimas, eksperimentai ir pažintinės užduotys žaismingam mokymuisi.',
    h1: 'Gamtos mokslų žaidimai vaikams',
    intro:
      'SmartPanda gamtos mokslų žaidimai padeda vaikams smalsiai tyrinėti pasaulį: stebėti gamtos reiškinius, pažinti gyvūnus ir jų buveines, suprasti orus bei mokytis kelti klausimus apie tai, kaip veikia aplinka.',
    about: [
      'gamtos mokslų žaidimai',
      'gamtos pažinimas',
      'gyvūnai ir jų buveinės',
      'orai ir gamtos reiškiniai',
    ],
    learningOutcomes: [
      'Gamtos reiškinių stebėjimas ir apibūdinimas',
      'Gyvūnų bei jų buveinių pažinimas',
      'Oro ir aplinkos pokyčių supratimas',
      'Smalsumo ir tyrinėjimo įgūdžių lavinimas',
      'Priežasties ir pasekmės ryšių pastebėjimas',
      'Mokymasis kelti klausimus ir ieškoti atsakymų',
    ],
    contentSections: [
      {
        title: 'Gamtos reiškinių pažinimas',
        text:
          'Gamtos mokslų užduotys leidžia vaikui mokytis stebint ir lyginant tai, ką jis mato aplink save. Interaktyvūs klausimai apie gamtą padeda pastebėti pokyčius, atpažinti reiškinius ir susieti naują informaciją su kasdieniais pavyzdžiais.',
      },
      {
        title: 'Gyvūnai ir jų buveinės',
        text:
          'Pažindamas gyvūnus vaikas gali mokytis, kur jie gyvena ir kaip aplinka susijusi su jų gyvenimu. Tokios užduotys lavina gebėjimą grupuoti informaciją, pastebėti panašumus bei skirtumus ir geriau suprasti gyvosios gamtos įvairovę.',
      },
      {
        title: 'Oras ir metų laikų pokyčiai',
        text:
          'Orai yra vaikui lengvai pastebima gamtos mokslų tema. Stebėdamas temperatūrą, debesis, kritulius ir kitus požymius vaikas mokosi apibūdinti aplinką, lyginti skirtingas sąlygas ir suprasti, kad gamta nuolat keičiasi.',
      },
      {
        title: 'Mokslinis smalsumas per žaidimą',
        text:
          'Mokymasis gamtos mokslų gali prasidėti nuo paprasto klausimo: kodėl taip vyksta? Žaidybinės užduotys suteikia vaikui progų stebėti, rinktis, tikrinti atsakymus ir ieškoti paaiškinimų. Taip ugdomas noras tyrinėti, o ne tik įsiminti faktus.',
      },
      {
        title: 'Mokymasis pastebėti ryšius',
        text:
          'Gamtos pasaulyje daugelis dalykų yra susiję. Vaikas gali mokytis pastebėti, kaip gyvūnai priklauso nuo savo aplinkos, kaip keičiasi orai ir kaip skirtingi gamtos reiškiniai gali būti tarpusavyje susiję. Tokios užduotys padeda lavinti loginį ir priežastinį mąstymą.',
      },
      {
        title: 'Kaip pasirinkti gamtos mokslų žaidimą vaikui?',
        text:
          'Renkantis užduotį verta atsižvelgti į vaiko amžių, turimas žinias ir tai, kas jį labiausiai domina. Vienam vaikui labiau patiks gyvūnai, kitam – orai ar eksperimentai. Geriausia pradėti nuo lengvai suprantamos temos ir palaipsniui pereiti prie sudėtingesnių klausimų.',
      },
    ],
    faq: [
      {
        question: 'Ką vaikai gali mokytis per gamtos mokslų žaidimus?',
        answer:
          'Vaikai gali pažinti gamtos reiškinius, gyvūnus ir jų buveines, orus bei mokytis stebėti aplinką, lyginti informaciją ir ieškoti atsakymų.',
      },
      {
        question: 'Ar gamtos mokslų žaidimai tinka pradinukams?',
        answer:
          'Taip. Interaktyvios užduotys gali būti naudojamos kaip papildoma praktika pradinio mokyklinio amžiaus vaikams, ypač kai mokymąsi norisi susieti su žaidimu.',
      },
      {
        question: 'Ar vaikas gali mokytis apie gyvūnus ir jų buveines?',
        answer:
          'Taip. „Gyvūnų Buveinės“ padeda mokytis susieti skirtingus gyvūnus su jiems būdinga aplinka.',
      },
      {
        question: 'Ar yra užduočių apie orus?',
        answer:
          'Taip. „Orų Stotis“ skirta orų ir gamtos pažinimo praktikai bei leidžia mokytis atpažinti ir apibūdinti skirtingas oro sąlygas.',
      },
      {
        question: 'Kaip sudominti vaiką gamtos mokslais?',
        answer:
          'Geriausia pradėti nuo vaikui pažįstamų reiškinių ir klausimų. Žaidimai, stebėjimas bei praktinės užduotys gali padėti gamtos mokslus susieti su kasdieniu pasauliu.',
      },
    ],
    relatedLinks: [
      {
        path: '/mokomieji-zaidimai',
        name: 'Visi mokomieji žaidimai',
      },
      {
        path: '/loginis-mastymas',
        name: 'Loginio mąstymo žaidimai',
      },
    ],
  },

  creative: {
    path: '/kurybiniai-zaidimai',
    topic: 'Kūrybiškumas',
    eyebrow: 'KŪRYBINIAI ŽAIDIMAI',
    title: 'Kūrybiniai žaidimai vaikams – SmartPanda',
    description:
      'Kūrybiniai žaidimai vaikams: istorijų kūrimas, vaizduotė, kūrybinis mąstymas ir kūrybinės užduotys žaismingam mokymuisi.',
    h1: 'Kūrybiniai žaidimai vaikams',
    intro:
      'SmartPanda kūrybiniai žaidimai padeda vaikams kurti, fantazuoti ir ieškoti savitų sprendimų. Istorijų kūrimas, vaizduotės užduotys ir kūrybiškumo veiklos leidžia mokytis ne tik randant vieną teisingą atsakymą, bet ir kuriant savo idėjas.',
    about: [
      'kūrybiniai žaidimai',
      'kūrybiškumo lavinimas',
      'vaizduotės užduotys',
      'istorijų kūrimas',
    ],
    learningOutcomes: [
      'Vaizduotės ir idėjų generavimo lavinimas',
      'Kūrybinio mąstymo ugdymas',
      'Istorijų ir pasakojimų kūrimas',
      'Gebėjimas savitai išreikšti mintis',
      'Skirtingų sprendimų ir idėjų ieškojimas',
      'Pasitikėjimo savo kūrybiniais pasirinkimais stiprinimas',
    ],
    contentSections: [
      {
        title: 'Vaizduotė ir idėjų kūrimas',
        text:
          'Kūrybiškumas prasideda nuo gebėjimo įsivaizduoti daugiau nei vieną galimybę. Kūrybinės užduotys skatina vaiką kurti idėjas, pastebėti netikėtus ryšius ir drąsiau eksperimentuoti su savo sumanymais.',
      },
      {
        title: 'Istorijų ir pasakojimų kūrimas',
        text:
          'Kuriant istorijas vaikas mokosi sugalvoti veikėjus, aplinką, įvykius ir jų seką. Tokia veikla kartu lavina kalbinę raišką, pasakojimo struktūros supratimą ir gebėjimą nuosekliai perteikti savo mintis.',
      },
      {
        title: 'Kūrybiškumas ir mokomieji dalykai',
        text:
          'Kūrybinis mąstymas nėra atskirtas nuo kitų mokomųjų dalykų. Pavyzdžiui, matematiką galima tyrinėti per formas, raštus ir kompozicijas, todėl kūrybinės užduotys gali padėti pažvelgti į mokymąsi iš kitos perspektyvos.',
      },
      {
        title: 'Mokymasis ieškant skirtingų sprendimų',
        text:
          'Kai užduotis leidžia rinktis ar kurti, vaikas mokosi nebijoti bandyti. Skirtingų idėjų generavimas ir jų palyginimas padeda ugdyti lankstų mąstymą bei gebėjimą ieškoti kelių būdų pasiekti tikslą.',
      },
      {
        title: 'Kūrybinė raiška per žaidimą',
        text:
          'Žaidybinė aplinka leidžia vaikui kurti be didelio spaudimo. Trumpi iššūkiai, istorijų idėjos ir kūrybiniai pasirinkimai suteikia progų eksperimentuoti, o atlikta užduotis tampa natūraliu paskatinimu tęsti kūrybinę veiklą.',
      },
      {
        title: 'Kaip pasirinkti kūrybinę užduotį vaikui?',
        text:
          'Verta pradėti nuo tos veiklos, kuri atitinka vaiko pomėgius. Jei vaikui patinka istorijos, tinka pasakojimo kūrimas, o jei domina formos ir vaizdai – kūrybinės matematikos užduotys. Svarbiausia suteikti erdvės pačiam vaikui priimti kūrybinius sprendimus.',
      },
    ],
    faq: [
      {
        question: 'Ką lavina kūrybiniai žaidimai?',
        answer:
          'Kūrybinės užduotys gali lavinti vaizduotę, idėjų generavimą, lankstų mąstymą, kalbinę raišką ir gebėjimą ieškoti skirtingų sprendimų.',
      },
      {
        question: 'Ar kūrybiniai žaidimai tinka vaikams, kurie nemėgsta rašyti?',
        answer:
          'Taip. Kūrybiškumą galima lavinti ne tik rašant tekstus, bet ir kuriant idėjas, formas, kompozicijas ar pasirenkant skirtingus sprendimus.',
      },
      {
        question: 'Ar yra žaidimų, kuriuose vaikas kuria istorijas?',
        answer:
          'Taip. „AI Pasakų Rašytojas“ skirtas istorijų ir pasakojimų kūrimui, todėl vaikas gali lavinti kūrybinę bei kalbinę raišką.',
      },
      {
        question: 'Ar kūrybiškumą galima lavinti kartu su matematika?',
        answer:
          'Taip. „Matematikos Meno Kūrėjas“ jungia matematinius elementus ir kūrybinę veiklą, todėl vaikas gali tyrinėti formas bei matematinius principus kūrybiškai.',
      },
      {
        question: 'Kaip skatinti vaiko kūrybiškumą?',
        answer:
          'Svarbu leisti vaikui siūlyti savo idėjas, bandyti skirtingus sprendimus ir neapsiriboti vienu teisingu atsakymu. Trumpi kūrybiniai žaidimai gali būti paprastas būdas reguliariai praktikuoti tokį mąstymą.',
      },
    ],
    relatedLinks: [
      {
        path: '/lietuviu-kalbos-zaidimai',
        name: 'Lietuvių kalbos žaidimai',
      },
      {
        path: '/teksto-supratimas',
        name: 'Teksto supratimo žaidimai',
      },
    ],
  },

};

export const TOPIC_HUBS = TOPIC_HUB_CONFIG;

export const SEO_CATEGORIES = CATEGORY_CONFIG;

export function getSEOCategory(category) {
  return CATEGORY_CONFIG[category] || CATEGORY_CONFIG.educational;
}


export const getSEOTopicHub = (topic) => TOPIC_HUB_CONFIG[topic];

export const SEOTopicPage = ({ topic }) => {
  const config = TOPIC_HUB_CONFIG[topic];

  if (!config) {
    return null;
  }

  const games = getGamesByTopic(config.topic);

  return (
    <SEOLandingPage
      {...config}
      canonical={config.path}
      category={topic}
      games={games}
      pageType="topic"
      breadcrumbName={config.eyebrow}
      childLinks={config.childLinks}
      relatedLinks={config.relatedLinks}
    />
  );
};

export const PreschoolGamesPage = () => {
  const config = AGE_HUB_CONFIG.preschool;

  return (
    <SEOLandingPage
      {...config}
      canonical={config.path}
      category="educational"
      games={getGamesByAgeHub('preschool')}
      pageType="age"
      breadcrumbName={config.eyebrow}
      relatedLinks={config.relatedLinks}
      trustAgeLabel="~4–6 metų"
    />
  );
};

export const PrimarySchoolGamesPage = () => {
  const config = AGE_HUB_CONFIG.primary;

  return (
    <SEOLandingPage
      {...config}
      canonical={config.path}
      category="educational"
      games={getGamesByAgeHub('primary')}
      pageType="age"
      breadcrumbName={config.eyebrow}
      relatedLinks={config.relatedLinks}
      trustAgeLabel="~6–10 metų"
    />
  );
};

export const LogicalThinkingPage = () => (
  <SEOTopicPage topic="logical" />
);

export const NumbersCountingPage = () => (
  <SEOTopicPage topic="numbers" />
);

export const VocabularyPage = () => (
  <SEOTopicPage topic="vocabulary" />
);

export const ReadingComprehensionPage = () => (
  <SEOTopicPage topic="comprehension" />
);

export const AttentionPage = () => (
  <SEOTopicPage topic="attention" />
);

export const ScienceGamesPage = () => (
  <SEOTopicPage topic="science" />
);

export const CreativeGamesPage = () => (
  <SEOTopicPage topic="creative" />
);

export default function SEOCategoryPages({ category = 'educational' }) {
  const config = getSEOCategory(category);
  const games = getGamesByCategory(category);

  return (
    <SEOLandingPage
      {...config}
      canonical={config.path}
      category={category}
      games={games}
      childLinks={config.childLinks}
      relatedLinks={config.relatedLinks}
    />
  );
}

// Backward-compatible named exports for existing App.js routes.
export function EducationalGamesPage() {
  return <SEOCategoryPages category="educational" />;
}

export function MathGamesPage() {
  return <SEOCategoryPages category="math" />;
}

export function ReadingGamesPage() {
  return <SEOCategoryPages category="reading" />;
}

export function LithuanianGamesPage() {
  return <SEOCategoryPages category="lithuanian" />;
}

export function SpeechGamesPage() {
  return <SEOCategoryPages category="speech" />;
}

// Additional backward-compatible named export used by App.js.
export function LithuanianLanguageGamesPage() {
  return <SEOCategoryPages category="lithuanian" />;
}
